import React from "react";
import * as Style from "./styles/loader";

function SpinLoader({ isLoading }) {
  return isLoading ? (
    <>
      <Style.Spinner />
    </>
  ) : null;
}

export default SpinLoader;
